export default [
  {
    path: '/course/content-base',
    name: 'content-base',
    component: () => import('@/views/modules/Content/ContentBase.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'content_manager',
          active: true,
        },
        {
          text: 'others.content_base',
          active: true,
        },
      ],
      resource: ['content_manager'],
    },
  },
]
